// extracted by mini-css-extract-plugin
export default {"layoutContainer":"Layout_layoutContainer__lnBGX","mainContent":"Layout_mainContent__aa1Gf"};